export default __webpack_public_path__ + "static/media/arrow-bendright-up.b87ad600.svg";